import { Typography } from "@material-ui/core";
import { Pacient } from "app/models/pacient";
import React from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Spinner } from "react-bootstrap";

interface PatientEvaluationsCardViewProps {
  patient: Pacient;
  loading?: boolean;
}

function PatientEvaluationsCardView({
  patient,
  loading = false,
}: PatientEvaluationsCardViewProps & WrappedComponentProps) {
  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            color: "#007896",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Typography variant="h5" style={{ marginTop: 10, color: "#007896" }}>
            {patient.name}
          </Typography>
          <Typography variant="body1" style={{ color: "#948d8d" }}>
            Avaliações
          </Typography>
          <Typography variant="body1" style={{ marginTop: 15 }}>
            <FormattedMessage id="PATIENTS_DASHBOARD.PAGE.CARD.EVALUATIONS.DESCRIPTION" />
          </Typography>
          <a
            href={`/pacients/${patient.id}/evaluations`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block",
              marginTop: 20,
              color: "#007896",
              border: "1px solid #007896",
              textAlign: "center",
              padding: "0.5rem",
              borderRadius: 10,
            }}
          >
            Ver Avaliações Completas <OpenInNewIcon />
          </a>
        </>
      )}
    </div>
  );
}

export default injectIntl(PatientEvaluationsCardView);
